// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__XcrZ7","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2IZQb"};